export const PASSENGERS_SITE_SECTION_ID = 'passengers-home';
export const BUSINESS_SITE_SECTION_ID = 'business-home';
export const CAREERS_SITE_SECTION_ID = 'careers-home';
export const OXD_AIRPORT_SITE_SECTION_ID = 'oxd-airport';
export const CVG_ELEVATE_SITE_SECTION_ID = 'cvg-elevate';

export enum SiteSectionIds {
	Passengers = PASSENGERS_SITE_SECTION_ID,
	Business = BUSINESS_SITE_SECTION_ID,
	Careers = CAREERS_SITE_SECTION_ID,
	OXD = OXD_AIRPORT_SITE_SECTION_ID,
	CvgElevate = CVG_ELEVATE_SITE_SECTION_ID,
}
